const state = {
  all: [],
  producao: {},
  producaoPeriodoPizza: {},
  desempenho: {},
  oee: {},
  tag: {},
  paradas: {
    tempo: {},
    quantidade: {}
  },
  tabela: {},
  tabelaResumo: {},
  tabeladesempenho: {},
  tabelaTotalDesempenho: {}
}

const mutations = {
  fillDataRelatorioProducao (state, res) {
    state.producao = res.data.linha
    state.producaoPeriodoPizza = res.data.pizza
  },
  fillDataRelatorioTag (state, res) {
    state.tag = res.data.grafico
    state.tabela = res.data.tabela
    state.tabelaResumo = res.data.tabelaResumo
  },
  fillDataRelatorioOee(state, res) {
    state.oee = res.data.grafico
    state.tabela = res.data.tabela
  },
  fillDataRelatorioParadas(state, res) {
    state.paradas.tempo = res.data.graficoTempo
    state.paradas.quantidade = res.data.graficoQtd
    state.tabela = res.data.tabela
  },
  fillDataRelatorioPedidosTempo (state, res) {
    state.desempenho = res.data.grafico
    state.tabeladesempenho = res.data.tabela
    state.tabelaTotalDesempenho = res.data.total
  }
}

const actions = {
  createRelatorioProducao(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/relatorios/producao', data).then((res) => {
      context.commit('fillDataRelatorioProducao', res)
      return res
    })
  },
  createRelatorioProducaoTag(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/relatorios/producao/tag', data).then((res) => {
      context.commit('fillDataRelatorioTag', res)
      return res
    })
  },
  createRelatorioProducaoPedidosTempo(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/relatorios/desempenho', data).then((res) => {
      context.commit('fillDataRelatorioPedidosTempo', res)
      return res
    })
  },
  updateProgramacao(context, data) {
    // let qs = require('querystring')
    // data = qs.stringify(data)
    // console.log(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/programacao', data).then((res) => {
      return res
    })
  },
  createRelatorioOee(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/relatorios/oee', data).then((res) => {
      context.commit('fillDataRelatorioOee', res)
      return res
    })
  },
  createRelatorioParadas(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/' + window.localStorage.getItem('projeto') + '/relatorios/paradas', data).then((res) => {
      context.commit('fillDataRelatorioParadas', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js